import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-people-add',
  templateUrl: './people-add.component.html',
  styleUrls: ['./people-add.component.sass']
})
export class PeopleAddComponent implements OnInit {
  uId;
  signupForm;
  coverPhoto: string = "./assets/img/cover-login.png";

  constructor(
    private fb: FormBuilder,
    public rout: Router,
    public auth: AuthenticationService,
    public db: FirestoreService
  ) { 
    this.signupForm = this.fb.group({
      nameFirst: [''],
      nameLast: [''],
      email: [''],
      password: [''],
    });
  }

  ngOnInit(): void {
  }

  addPeopleForm(){
    this.db.addPeople(this.signupForm.value);
  }

  routeToPeopleLoginPage(){
    this.rout.navigate(['people/login']);
  }
}
